export default __webpack_public_path__ + "static/media/deepthoughts.5d7b27d4.png";